import getRequest from '../../../getRequest';

/**
 * Get user rights mapping from PRISM db.
 *
 * @returns {object}
 */
function getUserRights() {
  const endpoint = '/users-management/get-user-rights/';

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get User Rights')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default getUserRights;
